<template>
  <nav class="navbar navbar-default">
    <div class="container">
      <!-- Brand and toggle get grouped for better mobile display -->
      <div class="navbar-header">
        <button type="button"
                class="navbar-toggle collapsed"
                @click="collapse = !collapse">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <router-link to="/" class="navbar-brand">
          <img src="/static/images/vetsouth-logo.png">
        </router-link>
        <ul class="nav navbar-nav navbar-left">
          <li>
            <router-link to="/">
              Home
            </router-link>
          </li>
        </ul>
      </div>

      <!-- Collect the nav links, forms, and other content for toggling -->
      <div class="navbar-collapse"
           :class="{collapse: collapse}"
           id="bs-example-navbar-collapse-1">

        <ul class="nav navbar-nav navbar-right">
          <li>
            <router-link  to="/login" >
              {{loggedIn ? `(${loggedIn.email}) Logout` : 'Login'}}
            </router-link>
          </li>

          <li>
            <connection-indicator></connection-indicator>
          </li>
        </ul>
      </div><!-- /.navbar-collapse -->
    </div><!-- /.container-fluid -->
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConnectionIndicator from './ConnectionIndicator'

export default {
  data() {
    return {
      collapse: true,
    }
  },
  components: {
    ConnectionIndicator,
  },
  computed: {
    ...mapState({
      account: state => state.account,
    }),
    ...mapGetters('connection', ['online']),
    loggedIn: function () {
      return this.account.user
    },
    hasPendingConsult: function() {
      return false
    },
  },
};
</script>

<style>
.navbar { padding: 6px 0; }
.navbar-default { background-color: transparent; }
.navbar-brand { padding: 0; }
.navbar-brand img { height: 50px }
</style>
